import BurgerMenu from './modules/BurgerMenu';
import { initSwiper } from './importSwiper';

document.addEventListener('DOMContentLoaded', () => {
    initSwiper();
});

document.addEventListener('DOMContentLoaded', () => {
    const burgerMenu = new BurgerMenu('.burger-menu', '.primary-menu', {
        closeOnOutsideClick: true,
        lockBodyScroll: true,
    });

    document.querySelector('.primary-menu').addEventListener('burger-open', () => {
        console.log('Menu is open');
    });

    document.querySelector('.primary-menu').addEventListener('burger-close', () => {
        console.log('Menu is close');
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const desktopAppPages = document.querySelectorAll('.home-block-desktop .app-page');
    const imageDisplay = document.getElementById('image-display');
    const desktopImageBlock = document.querySelector('.home-block-desktop__image');

    desktopAppPages.forEach((page) => {
        page.addEventListener('click', () => {
            desktopAppPages.forEach((p) => p.classList.remove('active'));

            page.classList.add('active');

            const newImage = page.getAttribute('data-image');
            if (newImage && imageDisplay) {
                imageDisplay.setAttribute('src', newImage);
            }

            const newColor = page.getAttribute('data-color');
            if (newColor && desktopImageBlock) {
                desktopImageBlock.className = 'home-block-desktop__image';
                desktopImageBlock.classList.add(newColor);
            }
        });
    });
});

// FAQ - Start
document.querySelectorAll('.faq-filter').forEach((button) => {
    button.addEventListener('click', () => {
        const filterValue = button.getAttribute('data-filter').toLowerCase();

        const faqFilteredContent = document.querySelector('.faq-filtered-content');
        faqFilteredContent.style.display = 'block';

        document.querySelectorAll('.faq-filter').forEach((btn) => {
            btn.classList.remove('active');
        });
        button.classList.add('active');

        document.querySelectorAll('.faq-category').forEach((catBlock) => {
            const catPlatformSlug = catBlock.getAttribute('data-platform');

            if (catPlatformSlug && catPlatformSlug.toLowerCase() === filterValue) {
                catBlock.style.display = 'flex';
            } else {
                catBlock.style.display = 'none';
            }
        });
    });
});

document.querySelectorAll('.accordion-header').forEach((header) => {
    header.addEventListener('click', () => {
        const expanded = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', !expanded);

        const content = header.nextElementSibling;
        if (!expanded) {
            content.style.maxHeight = content.scrollHeight + 'px';
        } else {
            content.style.maxHeight = null;
        }
    });
});
// FAQ - END

//Dropdown menu for language
document.addEventListener("DOMContentLoaded", () => {
    // DESKTOP
    const langBtnDesk = document.querySelector(".lang-switcher .lang-current");
    const dropdownDesk = document.querySelector(".lang-dropdown");

    if (langBtnDesk && dropdownDesk) {
        function positionDropdown() {
            const rect = langBtnDesk.getBoundingClientRect();
            const offsetY = 2;
            const offsetX = 64;

            dropdownDesk.style.position = "fixed";
            dropdownDesk.style.top = `${rect.bottom + offsetY}px`;
            dropdownDesk.style.left = `${rect.left - offsetX}px`;
        }

        langBtnDesk.addEventListener("click", (e) => {
            e.stopPropagation();
            dropdownDesk.classList.toggle("show");

            if (dropdownDesk.classList.contains("show")) {
                positionDropdown();
            }
        });

        document.addEventListener("click", (e) => {
            if (!e.target.closest(".lang-dropdown") && !e.target.closest(".lang-switcher .lang-current")) {
                dropdownDesk.classList.remove("show");
            }
        });

        window.addEventListener("scroll", () => {
            dropdownDesk.classList.remove("show");
        });

        window.addEventListener("resize", () => {
            if (dropdownDesk.classList.contains("show")) {
                positionDropdown();
            }
        });
    }

    // MOBILE
    const langBtnMob = document.querySelector(".lang-switcher-mob .lang-current-mob");
    const dropdownMob = document.querySelector(".lang-switcher-mob .lang-dropdown-mob");

    if (langBtnMob && dropdownMob) {
        langBtnMob.addEventListener("click", (e) => {
            e.stopPropagation();
            dropdownMob.classList.toggle("show");
        });

        document.addEventListener("click", (e) => {
            if (!e.target.closest(".lang-switcher-mob")) {
                dropdownMob.classList.remove("show");
            }
        });
    }
});
//END Dropdown menu for language

//Dropdown menu for main menu
document.addEventListener("DOMContentLoaded", () => {
    const isMobile = () => window.innerWidth <= 768;
    const header = document.querySelector('header');
    const parentItems = document.querySelectorAll('.primary-menu .menu-item-has-children');

    parentItems.forEach((item) => {
        const link = item.querySelector('a');
        const submenu = item.querySelector('.sub-menu');

        if (!submenu || !link || !header) return;

        if (!isMobile()) {
            // DESKTOP
            const clonedMenu = submenu.cloneNode(true);
            clonedMenu.classList.add('sub-menu-popup');
            header.appendChild(clonedMenu);
            submenu.remove();

            let hideTimeout;

            item.addEventListener('mouseenter', () => {
                const rect = link.getBoundingClientRect();
                clonedMenu.style.top = `${rect.bottom + 15}px`;
                clonedMenu.style.left = `${rect.left}px`;
                clonedMenu.classList.add('show');
                clearTimeout(hideTimeout);
            });

            item.addEventListener('mouseleave', () => {
                hideTimeout = setTimeout(() => {
                    clonedMenu.classList.remove('show');
                }, 200);
            });

            clonedMenu.addEventListener('mouseenter', () => {
                clearTimeout(hideTimeout);
            });

            clonedMenu.addEventListener('mouseleave', () => {
                hideTimeout = setTimeout(() => {
                    clonedMenu.classList.remove('show');
                }, 200);
            });

            window.addEventListener('resize', () => {
                if (clonedMenu.classList.contains('show')) {
                    const rect = link.getBoundingClientRect();
                    clonedMenu.style.top = `${rect.bottom + 6}px`;
                    clonedMenu.style.left = `${rect.left}px`;
                }
            });
        } else {
            // MOBILE
            link.addEventListener('click', (e) => {
                e.preventDefault();
                submenu.classList.toggle('show');
                item.classList.toggle('open');
            });

            parentItems.forEach((item) => {
                const link = item.querySelector('a');
                if (!link.querySelector('.submenu-toggle')) {
                    const arrow = document.createElement('span');
                    arrow.classList.add('submenu-toggle');
                    arrow.innerHTML = `
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                          <path d="M11.1406 1.6123L6.14062 6.6123L1.14062 1.6123" stroke="#2B2B2B" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>`;
                    link.appendChild(arrow);
                }
            });
        }
    });
});
//END Dropdown menu for main menu
